import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { getFormData } from "../helpers/common";
import { NhanVienResponse, NhanVienTheoDonViResponse, TimKiemNhanVienRequest, ThongKeNhanVienResponse, NhanVienTheoThamNienCongTacResponse, ThongKeNhanSuResponse, ThongKeNhanSuDoanDangRequest, ThongKeNhanSuDoanDangResponse } from "../models/nhanvien/NhanVien";
import { NguoiPhuThuocToanDonVi, TimKiemNguoiPhuThuocRequest } from "../models/nhanvien/NguoiPhuThuoc";
import { DataSelectBox } from "../models/selectbox";
import intance from "../utils/axios";
import { convertDataSelectBox } from "./danhmuc";

export const timKiemDSNhanVien = async (request:TimKiemNhanVienRequest, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.nhanVien.timKiemDsNhanVien, {
        "start": start,
        "length": length,
        "filter": {
            "idDonVi": request.idDonVi,
            "tuKhoa": request.tuKhoa || "",
            "idChucVu": request.idChucVu,
            "ngaySinh": request.ngaySinh || "",
            "idHocHam": request.idHocHam,
            "idNhomNhanSu": request.idNhomNhanSu,
            "maNhanVien": request.maNhanVien || "",
            "soDienThoai": request.soDienThoai || "",
            "trangThai": request.trangThai || null,
            "ten": request.ten || "",
            "email": request.email || "",
            "idChucDanh": request.idChucDanh,
            "gioiTinh": request.gioiTinh,
            "isKetHon": request.isKetHon,
            "idTrinhDoLLCT": request.idTrinhDoLLCT,
            "isDangVien": request.isDangVien,
            "isQuanNhan": request.isQuanNhan,
            "ngayVaoLam_TuNgay": request.ngayVaoLam_TuNgay || null,
            "ngayVaoLam_DenNgay": request.ngayVaoLam_DenNgay || null,
            "idLoaiQuyetDinh": request.idLoaiQuyetDinh || null,
            "ngayBatDauQTLV_TuNgay": request.ngayBatDauQTLV_TuNgay || null,
            "ngayBatDauQTLV_DenNgay": request.ngayBatDauQTLV_DenNgay || null,
            "ngayKetThucQTLV_TuNgay": request.ngayKetThucQTLV_TuNgay || null,
            "ngayKetThucQTLV_DenNgay": request.ngayKetThucQTLV_DenNgay || null,
            "daoTao_NgayBatDau_TuNgay": request.daoTao_NgayBatDau_TuNgay || null,
            "daoTao_NgayBatDau_DenNgay": request.daoTao_NgayBatDau_DenNgay || null,
            "daoTao_NgayKetThuc_TuNgay": request.daoTao_NgayKetThuc_TuNgay || null,
            "daoTao_NgayKetThuc_DenNgay": request.daoTao_NgayKetThuc_DenNgay || null,
            "daoTao_Ten": request.daoTao_Ten || "",
            "chungChi_NgayBatDau_TuNgay": request.chungChi_NgayBatDau_TuNgay || null,
            "chungChi_NgayBatDau_DenNgay": request.chungChi_NgayBatDau_DenNgay || null,
            "chungChi_NgayKetThuc_TuNgay": request.chungChi_NgayKetThuc_TuNgay || null,
            "chungChi_NgayKetThuc_DenNgay": request.chungChi_NgayKetThuc_DenNgay || null,
            "chungChi_Ten": request.chungChi_Ten || "",
            "danhGia_Nam": request.danhGia_Nam || null,
            "danhGia_KetQua": request.danhGia_KetQua || null,
            "khenThuong_ThanhTich": request.khenThuong_ThanhTich || "",
            "khenThuong_NgayQuyetDinh_TuNgay": request.khenThuong_NgayQuyetDinh_TuNgay || null,
            "khenThuong_NgayQuyetDinh_DenNgay": request.khenThuong_NgayQuyetDinh_DenNgay || null,
            "kyLuat_NoiDung": request.kyLuat_NoiDung || "",
            "kyLuat_NgayQuyetDinh_TuNgay": request.kyLuat_NgayQuyetDinh_TuNgay || null,
            "kyLuat_NgayQuyetDinh_DenNgay": request.kyLuat_NgayQuyetDinh_DenNgay || null,
            "tenChuyenNganhDaoTao": request.tenChuyenNganhDaoTao || "",
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layCTNhanVien = async (id: number) => {
    var rs: NhanVienResponse = new NhanVienResponse();

    await intance.get(ApiPaths.nhanVien.layCTNhanVien + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}

export const layLanhDaoPhuTrachPhongTheoDonVi = async (id: number) => {
    var rs: NhanVienResponse = new NhanVienResponse();
    await intance.get(ApiPaths.nhanVien.layCTLanhDaoPhuTrachPhongTheoIdDonVi + "?idDonVi=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}

export const xoaNhanVien = async (id: number) => {
    let rs = false
    await intance.get(ApiPaths.nhanVien.xoaNhanVien + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = true;
            }
        })
        .catch((error) => {
            throw error;
        })
    return rs;
}

export const layThongTinTheoMaChucVu = async (maChucVu: string, url : string) => {
    var rs: any;
    await intance.get(ApiPaths.nhanVien.layThongTinTheoMaChucVu + "?maChucVu=" + maChucVu + "&url=" + url)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuNhanVien = async (request: any) => {
    var response = { trangThai: responseStatus.loi, duLieu: 0 };
    var formData = getFormData(request);

    await intance.post(ApiPaths.nhanVien.luuNhanVien, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
        });
    return response;
};
export const luuDanhGiaXepLoai = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuDanhGiaXepLoai, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaDanhGiaXepLoai = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaDanhGiaXepLoai + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuQuaTrinhLamViec = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuQuaTrinhLamViec, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaQuaTrinhLamViec = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaQuaTrinhLamViec + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuKhenThuong = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuKhenThuong, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaKhenThuong = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaKhenThuong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuKyLuat = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuKyLuat, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaKyLuat = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaKyLuat + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuChungChi = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuChungChi, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChungChi = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaChungChi + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuQuaTrinhCongTac = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuQuaTrinhCongTac, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaQuaTrinhCongTac = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaQuaTrinhCongTac + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuTrinhDoHocVan = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.nhanVien.luuTrinhDoHocVan, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaTrinhDoHocVan = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaTrinhDoHocVan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
export const layDSNhanVienTheoQuyen = async (tenQuyen: string) => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.nhanVien.layDSNhanVienTheoQuyen + "?tenQuyen=" + tenQuyen)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDsNhanVien = async (tatCa?: boolean) => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.nhanVien.layDSToanBoNhanVien + "?showAll=" + (tatCa === true? "1": "0"))
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuNguoiPhuThuoc = async (data: any) => {
    await intance.post(ApiPaths.nhanVien.luuNguoiPhuThuoc, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaNguoiPhuThuoc = async (id: number) => {
    await intance.post(ApiPaths.nhanVien.xoaNguoiPhuThuoc + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xuatExcelNguoiPhuThuocToanDonVi = async (request: TimKiemNguoiPhuThuocRequest) => {
    var rs: any;
    await intance.post(ApiPaths.nhanVien.xuatExcelNguoiPhuThuocToanDonVi, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const timKiemNguoiPhuThuocToanDonVi = async (request: TimKiemNguoiPhuThuocRequest, start: number, length: number) => {
    var data = {
        data: [] as NguoiPhuThuocToanDonVi[],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.nhanVien.timKiemNguoiPhuThuocToanDonVi, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": request.tuKhoa || "",
            "idDonVi": request.idDonVi,
            "trangThai": request.trangThai,
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDsNhanVienTheoDonViTree = async () => {
    var data: Array<NhanVienTheoDonViResponse> = [];
    await intance.get(ApiPaths.nhanVien.danhSachTree)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuAnhDaiDien = async (request: any) => {
    var response = { trangThai: responseStatus.loi, duLieu: 0 };
    var formData = getFormData(request);

    await intance.post(ApiPaths.nhanVien.luuAnhDaiDien, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
        });
    return response;
};

export const layDsNLDTheoIdDonVi = async (id: number) => {
    var rs: Array<NhanVienResponse> = [];
    await intance.get(ApiPaths.nhanVien.LayDsNLDTheoIdDonVi)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}

export const layDsLanhDaoPhongTheoIdDonVi = async (idDonVi: number) => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.nhanVien.LayDsNLDTheoIdDonVi_V2 + `?idDonVi=${idDonVi}&isLayLanhDaoPhong=true`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
    return data;
}

export const XuatExcelNhanVienNghiViec = async (tuNgay: Date, denNgay: Date) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelNhanVienNghiViec, { params: { "fromDate": tuNgay, "toDate": denNgay }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const XuatExcelDieuDongLuanChuyen = async (tuNgay: Date, denNgay: Date) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelDieuDongLuanChuyen, { params: { "fromDate": tuNgay, "toDate": denNgay }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const thongKeNhanVien = async () => {
    var data: ThongKeNhanVienResponse = new ThongKeNhanVienResponse;
    await intance.get(`${ApiPaths.nhanVien.ThongKeNhanVien}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const LayDSNhanVienTheoThamNienCongTac = async (loaiThamNien: number) => {
    var data: Array<NhanVienTheoThamNienCongTacResponse> = [];
    await intance.get(`${ApiPaths.nhanVien.LayDSNhanVienTheoThamNienCongTac}`, { params: { "loaiThamNien": loaiThamNien } })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const XuatExcelNhanVienTheoThamNienCongTac = async (loaiThamNien: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelNhanVienTheoThamNienCongTac, { params: { "loaiThamNien": loaiThamNien }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const XuatExcelThongKeLoiViPham = async (nam: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelLoiViPhamTrongNam, { params: { "nam": nam }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const xuatExcelXepLoaiTrongNam = async (nam: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelXepLoaiTrongNam, { params: { "nam": nam }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const xuatExcelThuNhapTrongNam = async (nam: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelThuNhapTrongNam, { params: { "nam": nam }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}
 
export const thongKeNhanSuTheoPhongBan = async () => {
    var data: Array<ThongKeNhanSuResponse> = [];
    await intance.get(ApiPaths.nhanVien.ThongKeNhanSuTheoPhongBan)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const thongKeNhanSuTheoChucDanh = async () => {
    var data: Array<ThongKeNhanSuResponse> = [];
    await intance.get(ApiPaths.nhanVien.ThongKeNhanSuTheoChucDanh)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const luuTaiLieuNguoiPhuThuoc = async (files: any[], idNhanVien: number) => {
    var formData = new FormData();
    files.forEach((file, index) => {
        formData.append("files", file);
    })

    formData.append("idNhanVien", idNhanVien.toString());
    await intance.post(ApiPaths.nhanVien.luuTaiLieuNguoiPhuThuoc, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaTaiLieuNguoiPhuThuoc = async (id: number) => {
    await intance.get(ApiPaths.nhanVien.xoaTaiLieuNguoiPhuThuoc + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuTaiLieuHoSoNhanSu = async (file: any, idNhanVien: number) => {
    var formData = new FormData();

    formData.append("file", file);

    formData.append("idNhanVien", idNhanVien.toString());
    await intance.post(ApiPaths.nhanVien.luuTaiLieuHoSoNhanSu, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaTaiLieuHoSoNhanSu = async (id: number) => {
    await intance.get(ApiPaths.nhanVien.xoaTaiLieuHoSoNhanSu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};


export const xuatExcelNguoiPhuThuocTrongNam = async (nam: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.xuatExcelNguoiPhuThuocTrongNam, { params: { "nam": nam }, responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const xuatExcelNhanSuChuyenXepLuong = async (tuNgay: string, denNgay: string) => {
    let file = new Blob();
    await intance.get(ApiPaths.baoCao.xuatExcelNhanSuChuyenXepLuong, { params: { "tuNgay": tuNgay, "denNgay": denNgay }, responseType: 'blob' })
        .then((res: any) => {
            file = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        })
        .catch(err => {
            throw err;
        })
    return file;
};

export const thongKeNhanSuDoanDangTheoPhongBan = async (request?: ThongKeNhanSuDoanDangRequest) => {
    var data: Array<ThongKeNhanSuDoanDangResponse> = [];
    await intance.get(ApiPaths.nhanVien.ThongKeNhanSuDoanDangTheoPhongBan, {
        params: request
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}